// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e9e9b75","455":"afeee548"}[chunkId] + ".chunk.js";
};